import { DEFAULT_LLM } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";

import type { RecommendationsParamsDefinition } from "./RecommendationsRoutes.type";

const RECOMMENDATIONS_DEFAULT_DURATION = "6d";

export const params: RecommendationsParamsDefinition = {
    campaignId: {
        type: "string",
        dynamic: false,
    },
    model: {
        type: "string",
        value: DEFAULT_LLM,
    },
    duration: {
        type: "string",
        value: RECOMMENDATIONS_DEFAULT_DURATION,
    },
    topicsFilter: {
        type: "string",
        dynamic: false,
    },
    openCampaignPicker: {
        type: "bool",
        dynamic: true,
    },
    primaryTab: {
        type: "string",
        dynamic: true,
    },
    secondaryTab: {
        type: "string",
        dynamic: true,
    },
} as const;

export const ROUTES = {
    overview: "recommendations.frame.report.overview",
} as const;
